module.exports = __webpack_public_path__ + "img/wmv.509dc1df.png";